// Base content structure for image-based ratings
const baseGameLogoContent = {
  type: "image",
  inputType: "",
  label: "",
  data: {
    id: "",
    key: "",
    value: "",
    type: "rating",
    file: {},
    isUpdated: false,
  },
  translation: { input: "", flag: false, isUpdated: false },
};

// Helper function to create a rating entry
const createGameLogoEntry = (title: string, key: string) => ({
  title,
  content: {
    ...baseGameLogoContent,
    data: {
      ...baseGameLogoContent.data,
      key,
    },
  },
  isRequired: false,
  readonly: false,
  isButton: true,
});

// Rating entries
const gameLogoEntries = [
  { title: "Mock Game Logo", key: "mockGameLogo" },
];

// Generate ratings array
const mockGameLogo = gameLogoEntries.map(({ title, key }) => createGameLogoEntry(title, key));

export { mockGameLogo };
